import type { ActiveTrainState } from '@/types';

import { ARRIVAL_THRESHOLD, DEPARTURE_THRESHOLD } from '@/utils/constants/map';
import { interpolatePosition } from '@/utils/helpers/train-simulation/interpolate-position';

export const computeTrainPosition = (now: number, train: ActiveTrainState, coords: number[]) => {
  const {
    willStart,
    atCurrentStop,
    startTime,
    path,
    duration,
    totalDistance,
    segmentBearings,
    journeyFinished,
    pathDistance,
  } = train;

  const isStationary =
    willStart || atCurrentStop || totalDistance < 1 || (path?.length ?? 0) < 2 || duration <= 0;

  const progress = isStationary ? 0 : (now - startTime) / duration;

  // --- 1. START/STATIONARY BLOCK ---
  if (isStationary || progress < DEPARTURE_THRESHOLD) {
    coords[0] = path[0][0];
    coords[1] = path[0][1];

    return segmentBearings[0] ?? 0;
  }

  // --- 2. END/ARRIVAL BLOCK ---
  if (journeyFinished || progress > ARRIVAL_THRESHOLD) {
    const lastIdx = path.length - 1;
    coords[0] = path[lastIdx][0];
    coords[1] = path[lastIdx][1];

    return segmentBearings[Math.max(0, lastIdx - 1)] ?? 0;
  }

  // --- 3. MOVING BLOCK (Interpolation) ---
  const targetMeters = progress * totalDistance;

  const currentIdx = interpolatePosition(targetMeters, path, pathDistance, coords);

  return segmentBearings[currentIdx] ?? 0;
};
